import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';
import { RegulationRowModel } from './RegulationRowModel';

@Service()
export default class RegulationsManagementService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    private baseUrl(): string {
        return window.$config.HostName + 'api/regtech/regulations';
    }

    public async getList(category?: number | null): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            let url = this.baseUrl();
            if (category !== null && category !== undefined && category !== ('' as any)) {
                url += '?category=' + encodeURIComponent(String(category));
            }
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return { isSuccess: false, errorMessage: 'Request failed' };
        }
    }

    public async getById(id: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = this.baseUrl() + '/' + id;
            const response = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return response.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return { isSuccess: false, errorMessage: 'Request failed' };
        }
    }

    public async create(model: { regulations: string; category: number; status: number }): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const result = await this.axiosService.axiosInstance.post(this.baseUrl(), model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (error) {
            this.loaderService.HideLoader();
            const err = error as { response?: { data?: any } };
            if (err.response && err.response.data) {
                return err.response.data;
            }
            return { isSuccess: false, errorMessage: 'Request failed' };
        }
    }

    public async update(id: string, model: { regulations: string; status: number }): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = this.baseUrl() + '/' + id;
            const result = await this.axiosService.axiosInstance.put(url, model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (error) {
            this.loaderService.HideLoader();
            const err = error as { response?: { data?: any } };
            if (err.response && err.response.data) {
                return err.response.data;
            }
            return { isSuccess: false, errorMessage: 'Request failed' };
        }
    }

    public async remove(id: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = this.baseUrl() + '/' + id;
            const result = await this.axiosService.axiosInstance.delete(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (error) {
            this.loaderService.HideLoader();
            const err = error as { response?: { data?: any } };
            if (err.response && err.response.data) {
                return err.response.data;
            }
            return { isSuccess: false, errorMessage: 'Request failed' };
        }
    }
}
